import React from "react";
import Modal from "react-modal";
import "../show-docs-modal/show-doc-modal.scss";
import config from "../../../config";

const fileToShow = ["pdf", "jpg", "jpeg", "png", "svg"];

class ShowDocsModal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const STRATUS_URL = `${window.location.origin}/`;
    return (
      <div>
        <Modal isOpen={this.props.isOpen} className="doc-modal">
          {this.props.file == null ? (
            <p className="loader"></p>
          ) : (
            <>
              <div className="header dFlex">
                <h5>File : {this.props.file.title}</h5>
                <div className="opn-btn">
                  <a
                    className="download-link"
                    href={`${STRATUS_URL}powerapps/${this.props.file.id}/download`}
                    download={this.props.file.title}
                  >
                    {" "}
                    <i className="fa fa-download pointer"></i>{" "}
                  </a>
                  <button
                    className="close-modal"
                    onClick={() => this.props.close()}
                  >
                    {" "}
                    <i className="fa fa-times pointer"></i>
                  </button>
                </div>
              </div>

              {fileToShow.includes(
                this.props.file.type.toLowerCase(),
              ) === true ? (
                <>
                  {this.props.file.type == "pdf" ||
                    this.props.file.type == "PDF" ? (
                    <embed
                      src={`${STRATUS_URL}get-app-file/${this.props.file.id}`}
                      className="file-src"
                    />
                  ) : (
                    <div className="img-container">
                      <img
                        src={`${STRATUS_URL}get-app-file/${this.props.file.id}`}
                        className="doc-image"
                      />
                    </div>
                  )}
                </>
              ) : (
                <div className="msg-container">
                  <a
                    className="download-link"
                    href={
                      "powerapps/" +
                      this.props.file.id +
                      "/download"
                    }
                    download
                  >
                    <h4>
                      Preview not available please
                      download.
                    </h4>
                  </a>
                </div>
              )}
            </>
          )}
        </Modal>
      </div>
    );
  }
}

export default ShowDocsModal;
